/**
 * Text Component - Consistent text styling with theme support
 */

import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const Text = ({
  children,
  variant = 'body', // 'body', 'large', 'small', 'caption'
  color = 'primary', // 'primary', 'secondary', 'muted'
  weight = 'regular', // 'regular', 'medium', 'semibold', 'bold'
  align = 'left', // 'left', 'center', 'right'
  className = '',
  style = {}
}) => {
  const { theme } = useTheme();

  const getSize = () => {
    switch (variant) {
      case 'large':
        return theme.typography.sizes.lg;
      case 'small':
        return theme.typography.sizes.sm;
      case 'caption':
        return theme.typography.sizes.xs;
      default:
        return theme.typography.sizes.base;
    }
  };

  const getColor = () => {
    switch (color) {
      case 'secondary':
        return theme.colors.textSecondary;
      case 'muted':
        return theme.colors.textTertiary;
      default:
        return theme.colors.textPrimary;
    }
  };

  const getWeight = () => {
    return theme.typography.weights[weight] || theme.typography.weights.regular;
  };

  const baseStyles = {
    fontSize: getSize(),
    color: getColor(),
    fontWeight: getWeight(),
    textAlign: align,
    lineHeight: 1.6,
    ...style
  };

  return (
    <p className={`text ${className}`} style={baseStyles}>
      {children}
    </p>
  );
};

export default Text;